import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountName", "entityTypeIndividual", "entityTypeEntity"]

  connect() {
    // Listen for when this step becomes visible
    this.element.addEventListener('step:visible', this.onStepVisible.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('step:visible', this.onStepVisible.bind(this))
  }

  onStepVisible(event) {
    // Auto-populate account name when step becomes visible
    this.updateAccountName()
  }

  updateAccountName() {
    const individualRadio = this.entityTypeIndividualTarget
    const entityRadio = this.entityTypeEntityTarget

    if (individualRadio.checked) {
      // Auto-populate with first + last name from Step 1
      const firstName = document.querySelector('input[name*="[first_name]"]')?.value || ""
      const lastName = document.querySelector('input[name*="[last_name]"]')?.value || ""
      const fullName = [firstName, lastName].filter(n => n.trim()).join(" ")

      if (fullName && !this.accountNameTarget.value) {
        this.accountNameTarget.value = fullName
      }
    } else if (entityRadio.checked) {
      // Clear the account name field when Entity is selected
      this.accountNameTarget.value = ""
    }
  }

  toggleEntityType() {
    this.updateAccountName()
  }
}
